import { CSSObject } from "@emotion/react";

import { navAccent } from "../nav/navConstants";

export const navPinnedRowBarCss = (accentColor: string, opacity: number): CSSObject => ({
  flexShrink: 0,
  width: "3px",
  alignSelf: "stretch",
  minHeight: "1rem",
  borderRadius: "2px",
  background: accentColor,
  opacity,
});

export const navPinnedRowLabelCss = (isActive?: boolean): CSSObject => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontSize: "0.875rem",
  fontWeight: isActive ? 700 : 400,
});

type ActionButtonProps = React.PropsWithChildren<{
  title: string;
  onClick: () => void;
  color?: string;
  className?: string;
  isHoverReveal?: boolean;
  isDisabled?: boolean;
}>;

export const NavPinnedRowActionButton: React.FC<ActionButtonProps> = ({
  title,
  onClick,
  color,
  className,
  isHoverReveal,
  isDisabled,
  children,
}) => (
  <button
    type="button"
    className={className}
    title={title}
    aria-label={title}
    disabled={isDisabled}
    onClick={(event) => {
      event.preventDefault();
      event.stopPropagation();
      onClick();
    }}
    css={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      width: "1.25rem",
      height: "1.25rem",
      padding: 0,
      border: "none",
      background: "none",
      cursor: isDisabled ? "not-allowed" : "pointer",
      borderRadius: "0.25rem",
      color: color ?? navAccent,
      fontSize: "0.875rem",
      opacity: isDisabled ? 0.25 : isHoverReveal ? 0 : 0.7,
      transition: "opacity 0.1s linear",
      "&:hover": { opacity: isDisabled ? 0.25 : 1 },
      "&:focus-visible": { opacity: isDisabled ? 0.25 : 1 },
      "@media (hover: none)": { opacity: isDisabled ? 0.25 : 0.7 },
    }}
  >
    {children}
  </button>
);
